import { css } from '@emotion/core';
import { colors } from 'styles';

export const container = css`
  position: relative;
`;
